let UTILS = require("../libs/utils.js");
var v7772;
var v7773;
module.exports = {
  id: "car",
  name: "Carrier",
  alias: "car",
  endStats: ["sid", "name", "score", "kills", "deaths", "objective", "reward"],
  leaderStats: ["objective", "score"],
  preventCustomGames: true,
  objScore: 20,
  teamCarrierMlt: 1,
  nonCarrierMlt: 0.5,
  carrierMlt: 1.25,
  onKill: function (p9285, p9286, p9287) {
    p9285.dropFlag(p9287.flag);
  },
  oneflag: true,
  update: function (game, p9289, p9290) {
    if (game.map.manager.flags.length && (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) && (game.objectiveTimer -= p9290, game.objectiveTimer <= 0)) {
      game.objectiveTimer = 1500;
      var v7774 = game.connectedClients < 4 && !game.hasHost() && !game.isComp;
      for (var vLN01251 = 0; vLN01251 < game.players.list.length; ++vLN01251) {
        if (game.players.list[vLN01251].active && game.players.list[vLN01251].flag) {
          game.players.score(game.players.list[vLN01251], v7774 ? 1 : game.mode && game.mode.objScore ? game.mode.objScore : 10);
        }
      }
    }
  }
};